__turbopack_context__.v({
  "wrapper": "RichHtml-module__DneZSW__wrapper",
});
